import { IntegrationIconProps } from './types';

const Opsgenie = ({ dimension }: IntegrationIconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 16C19.866 16 23 12.866 23 9C23 5.13401 19.866 2 16 2C12.134 2 9 5.13401 9 9C9 12.866 12.134 16 16 16Z"
      fill="url(#paint0_linear_1334_1159)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4427 29.8294C11.174 26.9187 7.62385 22.9519 5.09252 18.2645C4.99467 18.0766 4.97339 17.854 5.03367 17.6488C5.09395 17.4437 5.23049 17.274 5.41127 17.1797L10.361 14.5832C10.7073 14.4027 11.1251 14.5396 11.3173 14.8965C13.8198 19.3799 17.5202 22.9603 21.9423 25.1768C20.3114 26.9333 18.5053 28.4935 16.5565 29.8294C16.2157 30.0569 15.7835 30.0569 15.4427 29.8294Z"
      fill="url(#paint1_linear_1334_1159)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5562 29.8294C20.8255 26.9194 24.3758 22.9524 26.9064 18.2645C27.0045 18.0771 27.0263 17.8549 26.9667 17.6498C26.9072 17.4447 26.7714 17.2747 26.5913 17.1797L21.6379 14.5832C21.2916 14.4027 20.8738 14.5396 20.6816 14.8965C18.1796 19.3803 14.4791 22.9609 10.0566 25.1768C11.6865 26.9345 13.4927 28.4948 15.4424 29.8294C15.7832 30.0569 16.2154 30.0569 16.5562 29.8294Z"
      fill="#2684FF"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1334_1159"
        x1="16"
        y1="4.32679"
        x2="16"
        y2="18.6996"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2684FF" />
        <stop offset="0.82" stopColor="#0052CC" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1334_1159"
        x1="11.9768"
        y1="18.2645"
        x2="15.8277"
        y2="28.5626"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2684FF" />
        <stop offset="0.62" stopColor="#0052CC" />
      </linearGradient>
    </defs>
  </svg>
);
export default Opsgenie;
